// Tidio migration import client: thin wrappers over apiFetch for
// /api/admin/sites/:siteId/import/tidio/*. Each call uploads one CSV file as
// the raw body; the server reports what it added and which rows it skipped.

import { apiFetch, isApiError } from './api';

export type TidioImportKind = 'contacts' | 'conversations' | 'knowledge';

export interface SkippedRow {
  row: number;
  reason: string;
}

export interface ContactImportResult {
  created: number;
  matched: number;
  skipped: SkippedRow[];
}

export interface ConversationImportResult {
  imported: number;
  duplicates: number;
  messages: number;
  skipped: SkippedRow[];
}

export interface KnowledgeImportResult {
  questions: number;
  entries: number;
  duplicateQuestions: number;
  websites: number;
  existingWebsites: number;
  rejectedWebsites: Array<{ url: string; reason: string }>;
  skipped: SkippedRow[];
}

interface Results {
  contacts: ContactImportResult;
  conversations: ConversationImportResult;
  knowledge: KnowledgeImportResult;
}

export async function importTidio<K extends TidioImportKind>(siteId: string, kind: K, file: File): Promise<Results[K]> {
  return apiFetch<Results[K]>(
    `/api/admin/sites/${siteId}/import/tidio/${kind}?filename=${encodeURIComponent(file.name)}`,
    { method: 'POST', body: await file.text(), headers: { 'Content-Type': 'text/csv' } },
  );
}

/** The server's human-readable `message`, when an error carries one. */
export function importErrorMessage(err: unknown): string | null {
  if (!isApiError(err)) return null;
  return (err.body as { message?: string } | null)?.message ?? null;
}
